
import { useState } from "react";
import { Drawer, Box, IconButton } from "@mui/material";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import CustomButton from "../../../../components/CustomButton";
import save from "../../../../assets/save.svg";
import { toast, Toaster } from "react-hot-toast";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption";
import { BASE_URL } from "../../../../components/BaseUrl";
import { useFormik } from "formik";

const AddDepartment = ({ open, onClose, onSuccess }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;

  const formik = useFormik({
    initialValues: {
      departmentName: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.departmentName || values.departmentName.trim() === "") {
        errors.departmentName = t("departments.addModal.departmentNameRequired") || "Department name is required";
      }
      return errors;
    },
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      if (!values.departmentName.trim()) {
        return;
      }

      setLoading(true);
      try {
        const res = await fetch(`${BASE_URL}/departments`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
          body: JSON.stringify({ name: values.departmentName }),
        });

        const data = await res.json();
        if (!res.ok || data.error) {
          throw new Error(data?.message || "Failed to add department.");
        }

        toast.success(t("departments.addModal.departmentAdded"));
        formik.resetForm();
        onClose();

        // call parent fetch
        if (onSuccess) onSuccess();
      } catch (err) {
        console.error("Error adding department:", err);
        toast.error(err.message || "Error while adding department.");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 400,
          maxWidth: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Toaster />
      {/* Header */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#E7EBEE",
          p: 1.3,
          borderBottom: "1px solid #E0E0E0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.2 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 20,
              fontWeight: 600,
              color: "#2C384C",
            }}
          >
            {t("departments.addModal.title")}
          </CustomText>
        </Box>
      </Box>

      {/* Body */}
      <Box sx={{ p: 2, overflowY: "auto", flexGrow: 1 }}>
        {/* Department Name */}
        <Box mb={2}>
          <label className="field_label">
            {t("departments.addModal.departmentName")}{" "}
            <span className="red_asterisk">*</span>
          </label>
          <input
            className="project_input"
            placeholder={t("departments.addModal.departmentNamePlaceholder")}
            style={{ 
              height: "40px", 
              width: "100%", 
              marginTop: 6,
              border: formik.touched.departmentName && formik.errors.departmentName
                ? "2px solid #d32f2f"
                : "2px solid #091E4224"
            }}
            name="departmentName"
            value={formik.values.departmentName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.departmentName && formik.errors.departmentName && (
            <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
              {formik.errors.departmentName}
            </span>
          )}
        </Box>

        {/* Save Button */}
        <Box sx={{ mt: 3 }}>
          <CustomButton
            onClick={formik.handleSubmit}
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {loading && (
                  <CircularProgress
                    size={18}
                    thickness={4}
                    sx={{ color: "#ffffff" }}
                  />
                )}
                <img src={save} alt="save" style={{ width: 16, height: 16 }} />
                {t("common.save")}
              </Box>
            }
            size="medium"
            disabled={loading}
          />
        </Box>
      </Box>
    </Drawer>
  );
};

export default AddDepartment;



// import { useState } from "react";
// import { Drawer, Box, IconButton } from "@mui/material";
// import profilecross from "../../../../assets/profilecross.svg";
// import CustomText, { textStyles } from "../../../../components/CustomText";
// import MultiSelectDropdown from "../../../../components/MultiSelectionDropdown";
// import CustomButton from "../../../../components/CustomButton";
// import save from "../../../../assets/save.svg";
// import { toast, Toaster } from "react-hot-toast";
// import CircularProgress from "@mui/material/CircularProgress";
// import { useTranslation } from "react-i18next";

// const AddDepartment = ({ open, onClose }) => {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [formValues, setFormValues] = useState({
//     departmentName: "",
//     headOfDepartment: [],
//     members: [],
//   });

//   const handleChange = (e) => {
//     setFormValues((prev) => ({
//       ...prev,
//       [e.target.name]: e.target.value,
//     }));
//   };

//   const handleAdd = () => {
//     if (
//       !formValues.departmentName ||
//       formValues.headOfDepartment.length === 0 ||
//       formValues.members.length === 0
//     ) {
//       toast.error(t("departments.addModal.fillAllFields"));
//       return;
//     }
//     setLoading(true);
//     setTimeout(() => {
//       setLoading(false);
//       toast.success(t("departments.addModal.departmentAdded"));
//       onClose();
//     }, 1000);
//   };

//   const dummyUsers = [
//     "John Doe",
//     "Jane Rotanson",
//     "Michal Mike",
//     "Lisa Michel",
//     "Selina Bill",
//   ];

//   return (
//     <Drawer
//       anchor="right"
//       open={open}
//       onClose={onClose}
//       PaperProps={{
//         sx: {
//           width: 530,
//           maxWidth: "100%",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//         },
//       }}
//     >
//       <Toaster />
//       <Box
//         sx={{
//           position: "sticky",
//           top: 0,
//           zIndex: 10,
//           backgroundColor: "#E7EBEE",
//           p: 1.3,
//           borderBottom: "1px solid #E0E0E0",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         <Box sx={{ display: "flex", alignItems: "center", gap: 0.2 }}>
//           <IconButton onClick={onClose}>
//             <img src={profilecross} alt="close" />
//           </IconButton>
//           <CustomText
//             sx={{
//               ...textStyles.h1,
//               fontSize: 20,
//               fontWeight: 600,
//               color: "#2C384C",
//             }}
//           >
//             {t("departments.addModal.title")}
//           </CustomText>
//         </Box>
//       </Box>

//       <Box sx={{ p: 2, overflowY: "auto", flexGrow: 1 }}>
//         <CustomText
//           sx={{
//             ...textStyles.h1,
//             fontSize: 16,
//             fontWeight: 600,
//             mb: 2,
//             color: "#172B4D",
//           }}
//         >
//           {t("departments.addModal.personalDetails")}
//         </CustomText>

//         {/* Department Name */}
//         <Box mb={2}>
//           <label className="field_label">
//             {t("departments.addModal.departmentName")}{" "}
//             <span className="red_asterisk">*</span>
//           </label>
//           <input
//             className="project_input"
//             placeholder={t("departments.addModal.departmentNamePlaceholder")}
//             style={{ height: "40px", width: "100%", marginTop: 6 }}
//             name="departmentName"
//             value={formValues.departmentName}
//             onChange={handleChange}
//           />
//         </Box>

//         {/* Head of Department Dropdown */}
//         <MultiSelectDropdown
//           label={
//             <>
//               {t("departments.addModal.headOfDepartment")}{" "}
//               <span style={{ color: "red" }}>*</span>
//             </>
//           }
//           name="headOfDepartment"
//           values={formValues.headOfDepartment}
//           onChange={handleChange}
//           options={dummyUsers}
//         />

//         {/* Members Dropdown */}
//         <MultiSelectDropdown
//           label={
//             <>
//               {t("departments.addModal.addMembers")}{" "}
//               <span style={{ color: "red" }}>*</span>
//             </>
//           }
//           name="members"
//           values={formValues.members}
//           onChange={handleChange}
//           options={dummyUsers}
//         />

//         {/* Save Button */}
//         <Box sx={{ mt: 3 }}>
//           <CustomButton
//             onClick={handleAdd}
//             label={
//               <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                 {loading && (
//                   <CircularProgress
//                     size={18}
//                     thickness={4}
//                     sx={{ color: "#ffffff" }}
//                   />
//                 )}
//                 <img src={save} alt="save" style={{ width: 16, height: 16 }} />
//                 {t("common.save")}
//               </Box>
//             }
//             size="medium"
//           />
//         </Box>
//       </Box>
//     </Drawer>
//   );
// };

// export default AddDepartment;
